import { Card } from 'antd';
import { getOmsRecycleOrderEmail } from 'apis/oms';
import LOCALS from 'commons/locals';
import UmsMemberEmailList from 'components/ums-member-email-list';
import { Mail } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { UmsMemberMail } from 'types/ums';

const OmsRecycleOrderEmail = ({ id }: { id?: string }) => {
  const [mailList, setMailList] = useState<UmsMemberMail[]>([]);
  useEffect(() => {
    if (!id) return;
    getOmsRecycleOrderEmail(id).then((res) => {
      setMailList(res);
    });
  }, [id]);

  return (
    <Card bodyStyle={{ padding: '16px' }}>
      <div className="flex items-center gap-2 mb-4 text-base font-medium">
        <Mail className="w-5 h-5" />
        <Trans i18nKey={LOCALS.email_history} />
      </div>
      <UmsMemberEmailList list={mailList} />
    </Card>
  );
};

export default OmsRecycleOrderEmail;
